import Kausana_1_320_Jpg from '@/assets/img/frontend/kausana/jpg/kausana-1_320.jpg';
import Kausana_1_480_Jpg from '@/assets/img/frontend/kausana/jpg/kausana-1_480.jpg';
import Kausana_1_768_Jpg from '@/assets/img/frontend/kausana/jpg/kausana-1_768.jpg';
import Kausana_1_320_Png from '@/assets/img/frontend/kausana/png/kausana-1_320.png';
import Kausana_1_480_Png from '@/assets/img/frontend/kausana/png/kausana-1_480.png';
import Kausana_1_768_Png from '@/assets/img/frontend/kausana/png/kausana-1_768.png';
import Kausana_1_320_Avif from '@/assets/img/frontend/kausana/avif/kausana-1_320.avif';
import Kausana_1_480_Avif from '@/assets/img/frontend/kausana/avif/kausana-1_480.avif';
import Kausana_1_768_Avif from '@/assets/img/frontend/kausana/avif/kausana-1_768.avif';
import Kausana_1_320_Webp from '@/assets/img/frontend/kausana/webp/kausana-1_320.webp';
import Kausana_1_480_Webp from '@/assets/img/frontend/kausana/webp/kausana-1_480.webp';
import Kausana_1_768_Webp from '@/assets/img/frontend/kausana/webp/kausana-1_768.webp';

import Hello_1_320_Jpg from '@/assets/img/frontend/helloword/jpg/hello-1_320.jpg';
import Hello_1_480_Jpg from '@/assets/img/frontend/helloword/jpg/hello-1_480.jpg';
import Hello_1_768_Jpg from '@/assets/img/frontend/helloword/jpg/hello-1_768.jpg';
import Hello_1_320_Png from '@/assets/img/frontend/helloword/png/hello-1_320.png';
import Hello_1_480_Png from '@/assets/img/frontend/helloword/png/hello-1_480.png';
import Hello_1_768_Png from '@/assets/img/frontend/helloword/png/hello-1_768.png';
import Hello_1_320_Avif from '@/assets/img/frontend/helloword/avif/hello-1_320.avif';
import Hello_1_480_Avif from '@/assets/img/frontend/helloword/avif/hello-1_480.avif';
import Hello_1_768_Avif from '@/assets/img/frontend/helloword/avif/hello-1_768.avif';
import Hello_1_320_Webp from '@/assets/img/frontend/helloword/webp/hello-1_320.webp';
import Hello_1_480_Webp from '@/assets/img/frontend/helloword/webp/hello-1_480.webp';
import Hello_1_768_Webp from '@/assets/img/frontend/helloword/webp/hello-1_768.webp';

import TecnoNews_1_320_Jpg from '@/assets/img/frontend/tecnonews/jpg/tecnonews-1_320.jpg';
import TecnoNews_1_480_Jpg from '@/assets/img/frontend/tecnonews/jpg/tecnonews-1_480.jpg';
import TecnoNews_1_768_Jpg from '@/assets/img/frontend/tecnonews/jpg/tecnonews-1_768.jpg';
import TecnoNews_1_320_Png from '@/assets/img/frontend/tecnonews/png/tecnonews-1_320.png';
import TecnoNews_1_480_Png from '@/assets/img/frontend/tecnonews/png/tecnonews-1_480.png';
import TecnoNews_1_768_Png from '@/assets/img/frontend/tecnonews/png/tecnonews-1_768.png';
import TecnoNews_1_320_Avif from '@/assets/img/frontend/tecnonews/avif/tecnonews-1_320.avif';
import TecnoNews_1_480_Avif from '@/assets/img/frontend/tecnonews/avif/tecnonews-1_480.avif';
import TecnoNews_1_768_Avif from '@/assets/img/frontend/tecnonews/avif/tecnonews-1_768.avif';
import TecnoNews_1_320_Webp from '@/assets/img/frontend/tecnonews/webp/tecnonews-1_320.webp';
import TecnoNews_1_480_Webp from '@/assets/img/frontend/tecnonews/webp/tecnonews-1_480.webp';
import TecnoNews_1_768_Webp from '@/assets/img/frontend/tecnonews/webp/tecnonews-1_768.webp';

import Alalata_1_320_Jpg from '@/assets/img/frontend/alalata/jpg/alalata-1_320.jpg';
import Alalata_1_480_Jpg from '@/assets/img/frontend/alalata/jpg/alalata-1_480.jpg';
import Alalata_1_768_Jpg from '@/assets/img/frontend/alalata/jpg/alalata-1_768.jpg';
import Alalata_1_320_Png from '@/assets/img/frontend/alalata/png/alalata-1_320.png';
import Alalata_1_480_Png from '@/assets/img/frontend/alalata/png/alalata-1_480.png';
import Alalata_1_768_Png from '@/assets/img/frontend/alalata/png/alalata-1_768.png';
import Alalata_1_320_Avif from '@/assets/img/frontend/alalata/avif/alalata-1_320.avif';
import Alalata_1_480_Avif from '@/assets/img/frontend/alalata/avif/alalata-1_480.avif';
import Alalata_1_768_Avif from '@/assets/img/frontend/alalata/avif/alalata-1_768.avif';
import Alalata_1_320_Webp from '@/assets/img/frontend/alalata/webp/alalata-1_320.webp';
import Alalata_1_480_Webp from '@/assets/img/frontend/alalata/webp/alalata-1_480.webp';
import Alalata_1_768_Webp from '@/assets/img/frontend/alalata/webp/alalata-1_768.webp';

import Wallar_1_320_Jpg from '@/assets/img/web-design/wallar/jpg/wallar-1_320.jpg';
import Wallar_1_480_Jpg from '@/assets/img/web-design/wallar/jpg/wallar-1_480.jpg';
import Wallar_1_768_Jpg from '@/assets/img/web-design/wallar/jpg/wallar-1_768.jpg';
import Wallar_1_320_Png from '@/assets/img/web-design/wallar/png/wallar-1_320.png';
import Wallar_1_480_Png from '@/assets/img/web-design/wallar/png/wallar-1_480.png';
import Wallar_1_768_Png from '@/assets/img/web-design/wallar/png/wallar-1_768.png';
import Wallar_1_320_Avif from '@/assets/img/web-design/wallar/avif/wallar-1_320.avif';
import Wallar_1_480_Avif from '@/assets/img/web-design/wallar/avif/wallar-1_480.avif';
import Wallar_1_768_Avif from '@/assets/img/web-design/wallar/avif/wallar-1_768.avif';
import Wallar_1_320_Webp from '@/assets/img/web-design/wallar/webp/wallar-1_320.webp';
import Wallar_1_480_Webp from '@/assets/img/web-design/wallar/webp/wallar-1_480.webp';
import Wallar_1_768_Webp from '@/assets/img/web-design/wallar/webp/wallar-1_768.webp';

import Maria_Gaceo_1_320_Jpg from '@/assets/img/web-design/maria_gaceo_psicologa/jpg/maria_gaceo_320.jpg';
import Maria_Gaceo_1_480_Jpg from '@/assets/img/web-design/maria_gaceo_psicologa/jpg/maria_gaceo_480.jpg';
import Maria_Gaceo_1_768_Jpg from '@/assets/img/web-design/maria_gaceo_psicologa/jpg/maria_gaceo_768.jpg';
import Maria_Gaceo_1_320_Png from '@/assets/img/web-design/maria_gaceo_psicologa/png/maria_gaceo_320.png';
import Maria_Gaceo_1_480_Png from '@/assets/img/web-design/maria_gaceo_psicologa/png/maria_gaceo_480.png';
import Maria_Gaceo_1_768_Png from '@/assets/img/web-design/maria_gaceo_psicologa/png/maria_gaceo_768.png';
import Maria_Gaceo_1_320_Avif from '@/assets/img/web-design/maria_gaceo_psicologa/avif/maria_gaceo_320.avif';
import Maria_Gaceo_1_480_Avif from '@/assets/img/web-design/maria_gaceo_psicologa/avif/maria_gaceo_480.avif';
import Maria_Gaceo_1_768_Avif from '@/assets/img/web-design/maria_gaceo_psicologa/avif/maria_gaceo_768.avif';
import Maria_Gaceo_1_320_Webp from '@/assets/img/web-design/maria_gaceo_psicologa/webp/maria_gaceo_320.webp';
import Maria_Gaceo_1_480_Webp from '@/assets/img/web-design/maria_gaceo_psicologa/webp/maria_gaceo_480.webp';
import Maria_Gaceo_1_768_Webp from '@/assets/img/web-design/maria_gaceo_psicologa/webp/maria_gaceo_768.webp';

import Fontarapid_Bilbao_320_Jpg from '@/assets/img/web-design/fontarapid_bilbao/jpg/fontarapid_bilbao_320.jpg';
import Fontarapid_Bilbao_480_Jpg from '@/assets/img/web-design/fontarapid_bilbao/jpg/fontarapid_bilbao_480.jpg';
import Fontarapid_Bilbao_768_Jpg from '@/assets/img/web-design/fontarapid_bilbao/jpg/fontarapid_bilbao_768.jpg';
import Fontarapid_Bilbao_320_Png from '@/assets/img/web-design/fontarapid_bilbao/png/fontarapid_bilbao_320.png';
import Fontarapid_Bilbao_480_Png from '@/assets/img/web-design/fontarapid_bilbao/png/fontarapid_bilbao_480.png';
import Fontarapid_Bilbao_768_Png from '@/assets/img/web-design/fontarapid_bilbao/png/fontarapid_bilbao_768.png';
import Fontarapid_Bilbao_320_Avif from '@/assets/img/web-design/fontarapid_bilbao/avif/fontarapid_bilbao_320.avif';
import Fontarapid_Bilbao_480_Avif from '@/assets/img/web-design/fontarapid_bilbao/avif/fontarapid_bilbao_480.avif';
import Fontarapid_Bilbao_768_Avif from '@/assets/img/web-design/fontarapid_bilbao/avif/fontarapid_bilbao_768.avif';
import Fontarapid_Bilbao_320_Webp from '@/assets/img/web-design/fontarapid_bilbao/webp/fontarapid_bilbao_320.webp';
import Fontarapid_Bilbao_480_Webp from '@/assets/img/web-design/fontarapid_bilbao/webp/fontarapid_bilbao_480.webp';
import Fontarapid_Bilbao_768_Webp from '@/assets/img/web-design/fontarapid_bilbao/webp/fontarapid_bilbao_768.webp';

import DJE_Burger_Bar_320_Jpg from '@/assets/img/web-design/dje_burger_bar/jpg/dje_burger_bar_320.jpg';
import DJE_Burger_Bar_480_Jpg from '@/assets/img/web-design/dje_burger_bar/jpg/dje_burger_bar_480.jpg';
import DJE_Burger_Bar_768_Jpg from '@/assets/img/web-design/dje_burger_bar/jpg/dje_burger_bar_768.jpg';
import DJE_Burger_Bar_320_Png from '@/assets/img/web-design/dje_burger_bar/png/dje_burger_bar_320.png';
import DJE_Burger_Bar_480_Png from '@/assets/img/web-design/dje_burger_bar/png/dje_burger_bar_480.png';
import DJE_Burger_Bar_768_Png from '@/assets/img/web-design/dje_burger_bar/png/dje_burger_bar_768.png';
import DJE_Burger_Bar_320_Avif from '@/assets/img/web-design/dje_burger_bar/avif/dje_burger_bar_320.avif';
import DJE_Burger_Bar_480_Avif from '@/assets/img/web-design/dje_burger_bar/avif/dje_burger_bar_480.avif';
import DJE_Burger_Bar_768_Avif from '@/assets/img/web-design/dje_burger_bar/avif/dje_burger_bar_768.avif';
import DJE_Burger_Bar_320_Webp from '@/assets/img/web-design/dje_burger_bar/webp/dje_burger_bar_320.webp';
import DJE_Burger_Bar_480_Webp from '@/assets/img/web-design/dje_burger_bar/webp/dje_burger_bar_480.webp';
import DJE_Burger_Bar_768_Webp from '@/assets/img/web-design/dje_burger_bar/webp/dje_burger_bar_768.webp';

import Balea_320_Jpg from '@/assets/img/web-design/balea/jpg/Balea_320.jpg';
import Balea_480_Jpg from '@/assets/img/web-design/balea/jpg/Balea_480.jpg';
import Balea_768_Jpg from '@/assets/img/web-design/balea/jpg/Balea_768.jpg';
import Balea_320_Png from '@/assets/img/web-design/balea/png/Balea_320.png';
import Balea_480_Png from '@/assets/img/web-design/balea/png/Balea_480.png';
import Balea_768_Png from '@/assets/img/web-design/balea/png/Balea_768.png';
import Balea_320_Avif from '@/assets/img/web-design/balea/avif/Balea_320.avif';
import Balea_480_Avif from '@/assets/img/web-design/balea/avif/Balea_480.avif';
import Balea_768_Avif from '@/assets/img/web-design/balea/avif/Balea_768.avif';
import Balea_320_Webp from '@/assets/img/web-design/balea/webp/Balea_320.webp';
import Balea_480_Webp from '@/assets/img/web-design/balea/webp/Balea_480.webp';
import Balea_768_Webp from '@/assets/img/web-design/balea/webp/Balea_768.webp';

import Ingune_320_Jpg from '@/assets/img/web-design/ingune/jpg/ingune_320.jpg';
import Ingune_480_Jpg from '@/assets/img/web-design/ingune/jpg/ingune_480.jpg';
import Ingune_768_Jpg from '@/assets/img/web-design/ingune/jpg/ingune_768.jpg';
import Ingune_320_Png from '@/assets/img/web-design/ingune/png/ingune_320.png';
import Ingune_480_Png from '@/assets/img/web-design/ingune/png/ingune_480.png';
import Ingune_768_Png from '@/assets/img/web-design/ingune/png/ingune_768.png';
import Ingune_320_Avif from '@/assets/img/web-design/ingune/avif/ingune_320.avif';
import Ingune_480_Avif from '@/assets/img/web-design/ingune/avif/ingune_480.avif';
import Ingune_768_Avif from '@/assets/img/web-design/ingune/avif/ingune_768.avif';
import Ingune_320_Webp from '@/assets/img/web-design/ingune/webp/ingune_320.webp';
import Ingune_480_Webp from '@/assets/img/web-design/ingune/webp/ingune_480.webp';
import Ingune_768_Webp from '@/assets/img/web-design/ingune/webp/ingune_768.webp';

let webDesign = [
  {
    imageId: 'maria-gaceo-1',
    altImg: 'Pantalla de la web oficial de «María Gaceo Psicología».',
    description: `Diseño web de <span class="bold">«María Gaceo Psicología»</span>, espacio terapéutico.`,
    srcAvif: Maria_Gaceo_1_768_Avif,
    srcAvif320: Maria_Gaceo_1_320_Avif,
    srcAvif480: Maria_Gaceo_1_480_Avif,
    srcAvif768: Maria_Gaceo_1_480_Avif ,
    srcAvif1080: Maria_Gaceo_1_768_Avif,
    srcWebp: Maria_Gaceo_1_768_Webp,
    srcWebp320: Maria_Gaceo_1_320_Webp,
    srcWebp480: Maria_Gaceo_1_480_Webp,
    srcWebp768: Maria_Gaceo_1_480_Webp ,
    srcWebp1080: Maria_Gaceo_1_768_Webp,
    srcPng: Maria_Gaceo_1_768_Png,
    srcPng320: Maria_Gaceo_1_320_Png,
    srcPng480: Maria_Gaceo_1_480_Png,
    srcPng768: Maria_Gaceo_1_480_Png ,
    srcPng1080: Maria_Gaceo_1_768_Png,
    srcJpg: Maria_Gaceo_1_768_Jpg,
    srcJpg320: Maria_Gaceo_1_320_Jpg,
    srcJpg480: Maria_Gaceo_1_480_Jpg,
    srcJpg768: Maria_Gaceo_1_480_Jpg ,
    srcJpg1080: Maria_Gaceo_1_768_Jpg,
    link: 'https://mariagaceopsicologia.com/',
    txtLink: 'Ir a María Gaceo Psicología',
  },  
  {
      imageId: 'kausana-1',
      altImg: 'Pantalla de la web oficial de «Kausana».',
      description: `Diseño y desarrollo de web oficial de <span class="bold">«Kausana»</span>, empresa de Desarrollo de Software.`,
      srcAvif: Kausana_1_768_Avif,
      srcAvif320: Kausana_1_320_Avif,
      srcAvif480: Kausana_1_480_Avif,
      srcAvif768: Kausana_1_480_Avif ,
      srcAvif1080: Kausana_1_768_Avif,
      srcWebp: Kausana_1_768_Webp,
      srcWebp320: Kausana_1_320_Webp,
      srcWebp480: Kausana_1_480_Webp,
      srcWebp768: Kausana_1_480_Webp ,
      srcWebp1080: Kausana_1_768_Webp,
      srcPng: Kausana_1_768_Png,
      srcPng320: Kausana_1_320_Png,
      srcPng480: Kausana_1_480_Png,
      srcPng768: Kausana_1_480_Png ,
      srcPng1080: Kausana_1_768_Png,
      srcJpg: Kausana_1_768_Jpg,
      srcJpg320: Kausana_1_320_Jpg,
      srcJpg480: Kausana_1_480_Jpg,
      srcJpg768: Kausana_1_480_Jpg ,
      srcJpg1080: Kausana_1_768_Jpg,
      link: 'https://kausana.cl/',
      txtLink: 'Ir a Kausana',
    },      
    {
      imageId: 'balea-1',
      altImg: 'Pantalla de la web oficial de «Balea».',
      description: `Diseño web de <span class="bold">«Balea»</span>, empresa especializada en reformas integrales y personalizadas.`,
      srcAvif: Balea_768_Avif,
      srcAvif320: Balea_320_Avif,
      srcAvif480: Balea_480_Avif,
      srcAvif768: Balea_480_Avif ,
      srcAvif1080: Balea_768_Avif,
      srcWebp: Balea_768_Webp,
      srcWebp320: Balea_320_Webp,
      srcWebp480: Balea_480_Webp,
      srcWebp768: Balea_480_Webp ,
      srcWebp1080: Balea_768_Webp,
      srcPng: Balea_768_Png,
      srcPng320: Balea_320_Png,
      srcPng480: Balea_480_Png,
      srcPng768: Balea_480_Png ,
      srcPng1080: Balea_768_Png,
      srcJpg: Balea_768_Jpg,
      srcJpg320: Balea_320_Jpg,
      srcJpg480: Balea_480_Jpg,
      srcJpg768: Balea_480_Jpg ,
      srcJpg1080: Balea_768_Jpg,
      link: 'https://baleareformas.com/', /* 'https://www.youtube.com/watch?v=CP77hvvZntw' */
      txtLink: 'Ir a Balea: reformas integrales',
    },
    {
      imageId: 'fontarapid-1',
      altImg: 'Pantalla de la web oficial de «Fontarapid Bilbao».',
      description: `Diseño web de <span class="bold">«Fontarapid Bilbao»</span>, empresa de fontanería.`,
      srcAvif: Fontarapid_Bilbao_768_Avif,
      srcAvif320: Fontarapid_Bilbao_320_Avif,
      srcAvif480: Fontarapid_Bilbao_480_Avif,
      srcAvif768: Fontarapid_Bilbao_480_Avif ,
      srcAvif1080: Fontarapid_Bilbao_768_Avif,
      srcWebp: Fontarapid_Bilbao_768_Webp,
      srcWebp320: Fontarapid_Bilbao_320_Webp,
      srcWebp480: Fontarapid_Bilbao_480_Webp,
      srcWebp768: Fontarapid_Bilbao_480_Webp ,
      srcWebp1080: Fontarapid_Bilbao_768_Webp,
      srcPng: Fontarapid_Bilbao_768_Png,
      srcPng320: Fontarapid_Bilbao_320_Png,
      srcPng480: Fontarapid_Bilbao_480_Png,
      srcPng768: Fontarapid_Bilbao_480_Png ,
      srcPng1080: Fontarapid_Bilbao_768_Png,
      srcJpg: Fontarapid_Bilbao_768_Jpg,
      srcJpg320: Fontarapid_Bilbao_320_Jpg,
      srcJpg480: Fontarapid_Bilbao_480_Jpg,
      srcJpg768: Fontarapid_Bilbao_480_Jpg ,
      srcJpg1080: Fontarapid_Bilbao_768_Jpg,
      link: 'https://fontarapidbilbao.com/',
      txtLink: 'Ir a Fontarapid Bilbao',
    },
    {
      imageId: 'ingune-1',
      altImg: 'Pantalla de la web oficial de «Ingune».',
      description: `Diseño web de <span class="bold">«Ingune»</span>, empresa de ingeniería del terreno.`,
      srcAvif: Ingune_768_Avif,
      srcAvif320: Ingune_320_Avif,
      srcAvif480: Ingune_480_Avif,
      srcAvif768: Ingune_480_Avif ,
      srcAvif1080: Ingune_768_Avif,
      srcWebp: Ingune_768_Webp,
      srcWebp320: Ingune_320_Webp,
      srcWebp480: Ingune_480_Webp,
      srcWebp768: Ingune_480_Webp ,
      srcWebp1080: Ingune_768_Webp,
      srcPng: Ingune_768_Png,
      srcPng320: Ingune_320_Png,
      srcPng480: Ingune_480_Png,
      srcPng768: Ingune_480_Png ,
      srcPng1080: Ingune_768_Png,
      srcJpg: Ingune_768_Jpg,
      srcJpg320: Ingune_320_Jpg,
      srcJpg480: Ingune_480_Jpg,
      srcJpg768: Ingune_480_Jpg ,
      srcJpg1080: Ingune_768_Jpg,
      link: 'https://ingune.es/', /* 'https://www.youtube.com/watch?v=gMZoSDe8tAE' */
      txtLink: 'Ir a Ingune: ingeniería del terreno',
    },
    {
      imageId: 'dje-burguer-1',
      altImg: 'Pantalla de la web oficial de «DJE Burger & Bar».',
      description: `Diseño web de <span class="bold">«DJE Burger & Bar»</span>, empresa de hamburguesas de autor.`,
      srcAvif: DJE_Burger_Bar_768_Avif,
      srcAvif320: DJE_Burger_Bar_320_Avif,
      srcAvif480: DJE_Burger_Bar_480_Avif,
      srcAvif768: DJE_Burger_Bar_480_Avif ,
      srcAvif1080: DJE_Burger_Bar_768_Avif,
      srcWebp: DJE_Burger_Bar_768_Webp,
      srcWebp320: DJE_Burger_Bar_320_Webp,
      srcWebp480: DJE_Burger_Bar_480_Webp,
      srcWebp768: DJE_Burger_Bar_480_Webp ,
      srcWebp1080: DJE_Burger_Bar_768_Webp,
      srcPng: DJE_Burger_Bar_768_Png,
      srcPng320: DJE_Burger_Bar_320_Png,
      srcPng480: DJE_Burger_Bar_480_Png,
      srcPng768: DJE_Burger_Bar_480_Png ,
      srcPng1080: DJE_Burger_Bar_768_Png,
      srcJpg: DJE_Burger_Bar_768_Jpg,
      srcJpg320: DJE_Burger_Bar_320_Jpg,
      srcJpg480: DJE_Burger_Bar_480_Jpg,
      srcJpg768: DJE_Burger_Bar_480_Jpg ,
      srcJpg1080: DJE_Burger_Bar_768_Jpg,
      link: 'https://djeburgerbar.com/',
      txtLink: 'Ir a DJE Burger & Bar',
    },
    {
      imageId: 'hello-1',
      altImg: 'Primer diseño de la web personal',
      description: `Diseño y desarrollo de mi anterior página web personal, titulada <span class="bold">«Hello World!»</span>.`,
      srcAvif: Hello_1_768_Avif,
      srcAvif320: Hello_1_320_Avif,
      srcAvif480: Hello_1_480_Avif,
      srcAvif768: Hello_1_480_Avif ,
      srcAvif1080: Hello_1_768_Avif,
      srcWebp: Hello_1_768_Webp,
      srcWebp320: Hello_1_320_Webp,
      srcWebp480: Hello_1_480_Webp,
      srcWebp768: Hello_1_480_Webp ,
      srcWebp1080: Hello_1_768_Webp,
      srcPng: Hello_1_768_Png,
      srcPng320: Hello_1_320_Png,
      srcPng480: Hello_1_480_Png,
      srcPng768: Hello_1_480_Png ,
      srcPng1080: Hello_1_768_Png,
      srcJpg: Hello_1_768_Jpg,
      srcJpg320: Hello_1_320_Jpg,
      srcJpg480: Hello_1_480_Jpg,
      srcJpg768: Hello_1_480_Jpg ,
      srcJpg1080: Hello_1_768_Jpg,
      link: 'https://ceciliadepaula.github.io/helloworld/',
      txtLink: 'Ir a Hello World!',
    },
    {
      imageId: 'wallar-1',
      altImg: 'Desarrollo de «Wallar»',
      description: `Diseño de <span class="bold">«Wallar»</span>, app para conectar a profesionales de la construcción.`,
      srcAvif: Wallar_1_768_Avif,
      srcAvif320: Wallar_1_320_Avif,
      srcAvif480: Wallar_1_480_Avif,
      srcAvif768: Wallar_1_480_Avif ,
      srcAvif1080: Wallar_1_768_Avif,
      srcWebp: Wallar_1_768_Webp,
      srcWebp320: Wallar_1_320_Webp,
      srcWebp480: Wallar_1_480_Webp,
      srcWebp768: Wallar_1_480_Webp ,
      srcWebp1080: Wallar_1_768_Webp,
      srcPng: Wallar_1_768_Png,
      srcPng320: Wallar_1_320_Png,
      srcPng480: Wallar_1_480_Png,
      srcPng768: Wallar_1_480_Png ,
      srcPng1080: Wallar_1_768_Png,
      srcJpg: Wallar_1_768_Jpg,
      srcJpg320: Wallar_1_320_Jpg,
      srcJpg480: Wallar_1_480_Jpg,
      srcJpg768: Wallar_1_480_Jpg ,
      srcJpg1080: Wallar_1_768_Jpg,
      link: 'https://www.behance.net/gallery/96709257/Wallar-UIUX',
      txtLink: 'Ir a Wallar',
    },
    {
      imageId: 'alalata-1',
      altImg: 'Desarrollo de «Alalata»',
      description: `Diseño y desarrollo de <span class="bold">«Alalata»</span>, taller de fotografía estenopeica.`,
      srcAvif: Alalata_1_768_Avif,
      srcAvif320: Alalata_1_320_Avif,
      srcAvif480: Alalata_1_480_Avif,
      srcAvif768: Alalata_1_480_Avif ,
      srcAvif1080: Alalata_1_768_Avif,
      srcWebp: Alalata_1_768_Webp,
      srcWebp320: Alalata_1_320_Webp,
      srcWebp480: Alalata_1_480_Webp,
      srcWebp768: Alalata_1_480_Webp ,
      srcWebp1080: Alalata_1_768_Webp,
      srcPng: Alalata_1_768_Png,
      srcPng320: Alalata_1_320_Png,
      srcPng480: Alalata_1_480_Png,
      srcPng768: Alalata_1_480_Png ,
      srcPng1080: Alalata_1_768_Png,
      srcJpg: Alalata_1_768_Jpg,
      srcJpg320: Alalata_1_320_Jpg,
      srcJpg480: Alalata_1_480_Jpg,
      srcJpg768: Alalata_1_480_Jpg ,
      srcJpg1080: Alalata_1_768_Jpg,
      link: 'https://ceciliadepaula.github.io/alalata/', 
      txtLink: 'Ir a Alalata',
    },
    {
      imageId: 'tecnonews-1',
      altImg: 'Desarrollo de «TecnoNews»',
      description: `Diseño y desarrollo de <span class="bold">«TecnoNews»</span>, portal de noticias tecnológicas.`,
      srcAvif: TecnoNews_1_768_Avif,
      srcAvif320: TecnoNews_1_320_Avif,
      srcAvif480: TecnoNews_1_480_Avif,
      srcAvif768: TecnoNews_1_480_Avif ,
      srcAvif1080: TecnoNews_1_768_Avif,
      srcWebp: TecnoNews_1_768_Webp,
      srcWebp320: TecnoNews_1_320_Webp,
      srcWebp480: TecnoNews_1_480_Webp,
      srcWebp768: TecnoNews_1_480_Webp ,
      srcWebp1080: TecnoNews_1_768_Webp,
      srcPng: TecnoNews_1_768_Png,
      srcPng320: TecnoNews_1_320_Png,
      srcPng480: TecnoNews_1_480_Png,
      srcPng768: TecnoNews_1_480_Png ,
      srcPng1080: TecnoNews_1_768_Png,
      srcJpg: TecnoNews_1_768_Jpg,
      srcJpg320: TecnoNews_1_320_Jpg,
      srcJpg480: TecnoNews_1_480_Jpg,
      srcJpg768: TecnoNews_1_480_Jpg ,
      srcJpg1080: TecnoNews_1_768_Jpg,
      link: 'https://ceciliadepaula.github.io/tecnonews/',
      txtLink: 'Ir a TecnoNews',
    },

    /* 
    novocel pagina vieja
    portal wisecity / novocel / mintral / tempora
    scanwater / scanmineral
    ccu
    tempora web?
    tecnoera
    netexplota diseño web, mailing
    */ 

]

export default webDesign;